import { Text } from '@mantine/core';
import type { ReactNode } from 'react';

/**
 * Each place the micro-label sits, and its size, ink, tracking and padding there: `section` in
 * the rail, the panels and the drawers; `group` over a list's groups (the sidebar's sections, the
 * push review's lists), smaller, wider and padded; `column` in a grid's header well, in ink
 * rather than dimmed.
 */
const VARIANTS = {
    section: { fz: 11, c: 'dimmed', letterSpacing: '0.06em' },
    group: { fz: 10, c: 'dimmed', letterSpacing: '0.15em', px: 'xs', pt: 'md', pb: 6 },
    column: { fz: 11, c: undefined, letterSpacing: '0.04em' },
} as const;

/** The uppercase micro-label — the design system's eyebrow. One definition for the rail, the panels, the drawers, the sidebar and the grid headers. */
export const SectionHeading = ({
    children,
    variant = 'section',
}: { children: ReactNode; variant?: keyof typeof VARIANTS }) => {
    const { letterSpacing, ...box } = VARIANTS[variant];
    return (
        <Text {...box} fw={600} tt="uppercase" style={{ letterSpacing }}>
            {children}
        </Text>
    );
};
